<template>
  <div class="overflow-hidden">
    <div class="container">
      <div class="lg:before:right bg-sand lg:before:bg-sand relative lg:before:absolute lg:before:inset-0 lg:before:w-screen">
        <div class="grid-side-content relative p-5 lg:px-0 lg:py-24">
          <h2 class="heading break-normal text-4xl lg:mx-auto lg:w-1/2 lg:text-5xl">
            {{ $t('Join') }}?
          </h2>
          <div>
            <div class="lg:text-2xl lg:font-medium">
              {{ $t('Join link below') }}
            </div>
            <Btn
              :to="registerUrl"
              :label="$t('Join link')"
              :short-label="$t('Join')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig();
const registerUrl = config.public.registerUrl;
</script>
